import React, { useState } from 'react';
import './GroupCard.css';
import { FaEye } from 'react-icons/fa';
import DetailModal from './DetailModal';

const GroupCard = ({ group, isSelected, onClick, onEdit }) => {
  const [showDetail, setShowDetail] = useState(false);

  return (
    <>
      <div className="group-card-wrapper">
        <div 
          className={`group-card-temp ${isSelected ? 'selected' : ''}`} 
          onClick={onClick}
        >
          <FaEye 
            className="detail-temp-icon" 
            onClick={(e) => {
              e.stopPropagation();
              setShowDetail(true);
            }}
          />
          
          <div className="group-card-temp-content">
            <div className="group-card-temp-field">
              <div className="group-card-temp-category">ГРУППА</div>
              <div className="group-card-temp-title">{group.name}</div>
            </div>

            <div className="group-card-temp-field">
              <div className="group-card-temp-category">КОЛИЧЕСТВО ЧЕЛОВЕК</div>
              <div className="group-card-temp-value">{group.users.length}</div>
            </div>

            <div className="group-card-temp-field">
              <div className="group-card-temp-category">ДАТА СОЗДАНИЯ</div>
              <div className="group-card-temp-value">{group.date_create || 'Дата отсутствует'}</div>
            </div>

            <div className="group-card-temp-field">
              <div className="group-card-temp-category">УЧАСТНИКИ</div>
              <div className="group-participants-tags">
                {group.users.slice(0, 3).map(user => (
                  <span key={user.user_id} className="participant-tag">
                    {user.user_name}
                  </span>
                ))}
                {group.users.length > 3 && (
                  <span className="participant-more">+{group.users.length - 3} ещё</span>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {showDetail && (
        <DetailModal 
          data={group} 
          type="group" 
          onClose={() => setShowDetail(false)}
          onEdit={onEdit ? () => onEdit(group) : null}
        />
      )}
    </>
  );
};

export default GroupCard;